import { CERTA_API_URL } from 'config';
import { postWithResponse } from './fetch';
import { TokenResponse } from 'types/api/token-response';

export async function refreshToken(token: string): Promise<TokenResponse> {
  return await postWithResponse<TokenResponse>(CERTA_API_URL + '/token/refresh', {}, token);
}


// WEBPACK FOOTER //
// ./src/api/token-api.ts